import { render, staticRenderFns } from "./limited_textarea.vue?vue&type=template&id=9d5ab40a&"
import script from "./limited_textarea.vue?vue&type=script&lang=js&"
export * from "./limited_textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports